const ActionExtractType = [
    {
        value : 'number',
        text : 'Number'
    },
    {
        value : 'text',
        text : 'Text'
    },
    {
        value : 'date',
        text : 'Date'
    },
    {
        value : 'city',
        text : 'City'
    },
    {
        value : 'civility',
        text : 'Civility'
    },
    {
        value : 'time',
        text : 'Specific time'
    },
    {
        value : 'postcode',
        text : 'Zip code'
    },
    {
        value : 'department',
        text : 'Department'
    },
    {
        value : 'firstname',
        text : 'Firstname'
    },
    {
        value : 'lastname',
        text : 'Lastname'
    }
]

export default ActionExtractType;